import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
import moment from "moment";
import apiService from "../../api/api.service";
import telematicsService from "../../api/telematics.service";
import rules from "../../utils/rules";
import config from "../../../secrets/config";
import app from "@/utils/app.json";

export default {
  name: "reservation-report",
  components: { pageheader },
  data() {
    return {
      rules: rules,
      configdata: config.ENABLE_ACCESS_CODE,
      usersList: [],
      isLoaderUser: false,
      selectedUser: "",
      selected: [
        "Geofence",
        "Group",
        "Jobsite",
        "Model",
        "Access Control Codes",
        "Search Field",
      ],
      monthlyListDropDown: app.monthlylistdropdown,
      selectMonthlyDay: null,
      filterTypes: [
        { id: "3", name: "Geofence" },
        { id: "4", name: "Group" },
        { id: "5", name: "Jobsite" },
        { id: "6", name: "Model" },
        { id: "7", name: "Access Control Codes" },
        { id: "9", name: "Search Field" },
      ],
      filterTypesWithoutAccess: [
        { id: "3", name: "Geofence" },
        { id: "4", name: "Group" },
        { id: "5", name: "Jobsite" },
        { id: "6", name: "Model" },
        { id: "9", name: "Search Field" },
      ],
      selectedOwnershipType: ["1", "2"],
      selectedOwnershipFinal: "",
      ownershipTypes: [
        { name: "Equipment on rent", value: "1" },
        { name: "Assets", value: "2" },
      ],
      searchField: "",
      searchContractId: "",
      searchMenu: false,
      selectedGroup: [],
      selectedGroupCount: "",
      groups: [],
      selectedMachine: [],
      selectedMachineCount: "",
      machines: [],
      menu1: false,
      menu2: false,
      fromDate: "",
      toDate: "",
      valid: true,
      closeOnContentClick: false,
      groupSearchFilter: "",

      machineSearchFilter: "",
      locationMenu: false,
      selectedLocation: "",
      selectedLocationCount: "",
      locations: [],
      loadinglocations: false,
      selectedModel: [],
      selectedModelCount: "",
      modelSearchFilter: "",
      models: [],
      loadingmodel: false,
      zonesList: [],
      selectedZone: [],
      zoneSearchFilter: "",
      menufilter: false,
      selectedJobSite: [],
      input: {},
      search: "",
      show1: false,
      isReportLoading: false,
      isReportExporting: false,
      selectedExportOption: null,
      exportOptions: ["Excel", "PDF"],
      isDownloading: false,
      loading: false,
      reportDataList: [],
      header: [
        { text: "Access Control Code", value: "accessControlCode", sortable: true, width: "160px" },
        { text: "Equipment #", value: "stockKey" },
        { text: "Equipment", value: "name" },
        { text: "Telematics SN", value: "tuSerialNumber" },
        { text: "Customer Name", value: "customerName" },
        { text: "Contract#", value: "contractId" },
        { text: "Item Status", value: "itemStatus" },
        { text: "Quantity", value: "quantity" },

        { text: "Start Date", value: "initialContractDate" },
        { text: "Estimated Return Date", value: "contractEndDate" },
        { text: "PO#", value: "customerPurchaseOrder" },
        { text: "Job#", value: "customerJobNumber" },
        { text: "Ordered By", value: "orderedBy" },
        { text: "Picked Up by", value: "pickedUpBy" },
        { text: "Model", value: "model" },
        { text: "Jobsite", value: "jobSite" },
      ],
      pageNumber: 1,
      pageSize: 100,
      totalRecords: 0,
      totalRecordsCount: 0,
      countLables: [
        {
          name: "25",
          count: 25,
        },
        {
          name: "50",
          count: 50,
        },
        {
          name: "100",
          count: 100,
        },
        {
          name: "ALL",
          count: -1,
        },
      ],
      selectedAccessControlCodesNames: [],
      //access
      selectedAccessControlCodes: [],
      selectedAccessControlCodesCount: "",
      accessControlCodesSearchFilter: "",
      accessControlCodes: [],
      loadingaccesscontrolcodes: false,
      //end
      jobSiteSearchFilter: "",
      // scheduled reports data fields
      jobSiteSearchFilterSchedule: "",
      searchContractIdSchedule: "",

      searchemail: null,
      emailitems: [],
      emails: [],
      Scheduledheader: [
        { text: "Company", value: "customerName", width: "10px" },

        { text: "Name", value: "name", width: "10px" },

        { text: "Format", value: "format", width: "10px" },
        { text: "Frequency", value: "frequency", width: "10px" },

        { text: "Emails", value: "emails", width: "10px" },
        { text: "Action", value: "action", width: "10px" },
      ],
      scheduledFrequency: "",
      FrequencyListDropDown: ["Daily", "Weekly", "Biweekly", "Monthly"],
      scheduledTypeListDropdown: ["Excel", "PDF"],
      scheduledType: "",

      zoneSearchFilterSchedule: "",
      menufilterSchedule: false,
      modelSearchFilterSchedule: "",
      groupSearchFilterSchedule: "",
      accessControlCodesSearchFilterSchedule: "",
      selectedcust: "",

      searchFieldSchedule: "",
      searchSchedule: "",
      ScheduleReportName: "ONRESRVREPORT",
      searchMenuSchedule: false,
      selectedschedule: {},
      scheduleedit: false,
      selectedZonesNamesSchedule: [],
      selectedJobSiteNamesSchedule: [],
      selectedModelNamesSchedule: [],
      timeSearchFilterSchedule: "",
      selectedAccessControlCodesNamesSchedule: [],
      selectedGroupSchedule: [],
      selectedModelSchedule: [],
      selectedAccessControlCodesSchedule: [],
      selectedJobSiteSchedule: [],
      selectedZoneSchedule: [],
      displayScheduledForm: false,
      scheduledialog: false,
      confirmdialog: false,
      isdelete: false,
      scheduleformvalid: true,
      isSaveScheduleLoading: false,
      isupdateScheduleLoading: false,
      scheduleName: "",
      scheduledList: [],
      isScheduledListLoading: false,
      ScheduledWeekDaysList: [
        {
          name: "Sunday",
          value: "0",
        },
        {
          name: "Monday",
          value: "1",
        },
        {
          name: "Tuesday",
          value: "2",
        },
        {
          name: "Wednesday",
          value: "3",
        },
        {
          name: "Thursday",
          value: "4",
        },
        {
          name: "Friday",
          value: "5",
        },
        {
          name: "Saturday",
          value: "6",
        },
      ],
      selectedDays: [],
      // end scheduled reports data fields
    };
  },
  watch: {
    emails(val, prev) {
      if (val.length === prev.length) return;
      this.emails = val.map((v) => {
        return v;
      });
    },
  },
  computed: {
    ...mapGetters(["roles", "companyIdDropdown", "companyNameDropdown"]),
    startPageCount() {
      return this.pageNumber == -1
        ? 1
        : (this.pageNumber - 1) * this.pageSize + 1;
    },
    endPageCount() {
      return this.pageNumber == -1 || this.pageNumber == 1
        ? this.reportDataList.length
        : (this.pageNumber - 1) * this.pageSize + this.reportDataList.length;
    },
  },
  mounted() {
    this.input = utils.getInputContent("onReservationReport", this.roles);
    this.getGroups();
    this.getMachines();
    this.getLocations();
    this.getModels();
    this.getZones();
    this.getAccessControlCodes();

    this.readReportListFromAPI();
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        let date = value.split("T")[0];
        return moment(date).format(format);
      }
    },
    formatTimeStamp: function (val) {
      return moment.utc(val * 1000).format("HH:mm:ss");
    },
  },
  methods: {
    async getAccessControlCodes() {
      try {
        this.loadingaccesscontrolcodes = true;
        let owrtype, id;
        let cust;
        if (
          this.companyIdDropdown == "" ||
          this.companyIdDropdown == null ||
          this.companyIdDropdown == undefined
        ) {
          cust = "All";
          id = "";
        } else {
          cust = this.$store.getters.companyIdDropdown;
          id = this.$store.getters.companyIdDropdown;
        }
        if (cust == "All") {
          owrtype = "1";
        } else {
          owrtype = "2";
        }
        let response = await telematicsService.getAccessKeysList(id, owrtype);
        if (response) {
          this.accessControlCodes = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              serialNumber: item.serialNumber ? item.serialNumber : "",
              accesscontrolcode: String(index),
              showCodeName:
                (item.serialNumber ? item.serialNumber + " - " : "") +
                (item.name ? item.name : ""),
            };
          });

          this.loadingaccesscontrolcodes = false;
        }
      } catch (err) {
        this.loadingaccesscontrolcodes = false;
        console.log(err);
      }
    },
    getList(item, queryText, itemText) {
      return itemText
        .toLocaleLowerCase()
        .startsWith(queryText.toLocaleLowerCase().trim());
    },
    joinOrEmpty(list, encode = false) {
      if (list.length > 0) {
        const value = list.join(",");
        return encode ? encodeURIComponent(value) : value;
      }
      return "";
    },
    computeOwnershipFinal(ownershipType) {
      return ownershipType.length == 0 || ownershipType.length == 2
        ? "0"
        : ownershipType[0];
    },
    triggerDownload(response, fileName, mimeType) {
      const url = window.URL.createObjectURL(
        new Blob([response], { type: mimeType })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      // deferred a tick: revoking in the same tick as click() can abort the
      // download in Firefox and Safari
      setTimeout(() => window.URL.revokeObjectURL(url), 0);
      this.isDownloading = false;
    },
    direction(item) {
      this.$router.push("/?searchkey=" + encodeURIComponent(item.stockKey));
    },

    async readReportListFromAPI() {
      this.reportDataList = [];
      this.isReportLoading = true;
      let date1 = "";
      let date2 = "";
      date1 = this.fromDate;
      date2 = this.toDate;
      //All Reports Filters
      let machineIds, zone, groupIds, jobSite, model;
      let accessControlCodes = this.joinOrEmpty(this.selectedAccessControlCodes);
      let searchValue = "";
      if (this.searchField) {
        searchValue = this.searchField;
      } else {
        searchValue = "";
      }
      let searchContractValue = "";
      if (this.searchContractId) {
        searchContractValue = this.searchContractId;
      } else {
        searchContractValue = "";
      }
      machineIds = this.joinOrEmpty(this.selectedMachine, true);
      groupIds = this.joinOrEmpty(this.selectedGroup);
      model = this.joinOrEmpty(this.selectedModel);
      jobSite = this.joinOrEmpty(this.selectedJobSite);
      zone = this.joinOrEmpty(this.selectedZone);
      //End Report Filters
      try {
        let response = await telematicsService.getOnReservationList(
          Number(this.selectedOwnershipFinal),
          date1,
          date2,
          machineIds,
          zone,
          groupIds,
          jobSite,
          accessControlCodes,
          model,
          searchValue,
          searchContractValue,
          this.pageNumber,
          this.pageSize
        );
        if (response.isSuccess) {
          this.isReportLoading = false;
          this.reportDataList = response.data;
          this.totalRecordsCount = response.totalRecords;
          let totalRecords = Math.ceil(this.totalRecordsCount / this.pageSize);
          if (this.pageSize == -1) {
            this.totalRecords = 1;
          } else {
            this.totalRecords = parseInt(totalRecords);
          }
        } else {
          this.isReportLoading = false;
          this.reportDataList = [];
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
      }
    },
    accessControlCodeChange() {
      this.selectedAccessControlCodesNames = [];
      this.selectedAccessControlCodesNames =
        this.selectedAccessControlCodes.map(
          (serialNumber) =>
            this.accessControlCodes.find(
              (el) => el.serialNumber == serialNumber
            ).showCodeName
        );
    },
    resetAccessControlCodes() {
      this.selectedAccessControlCodes = [];
      this.selectedAccessControlCodesNames = [];
    },
    clearSearch() {
      this.searchField = "";
    },
    OnOwnerTypeChange() {
      this.selectedOwnershipFinal = this.computeOwnershipFinal(
        this.selectedOwnershipType
      );
    },
    resetOwnerType() {
      this.selectedOwnershipType = ["1", "2"];
      this.selectedOwnershipFinal = "0";
    },
    pageChange() {
      this.readReportListFromAPI();
    },
    async readReportListFromAPIExport() {
      this.isDownloading = true;
      let searchValue = "";
      if (this.searchField) {
        searchValue = this.searchField;
      } else {
        searchValue = "";
      }
      let searchContractValue = "";
      if (this.searchContractId) {
        searchContractValue = this.searchContractId;
      } else {
        searchContractValue = "";
      }
      let date1 = "";
      let date2 = "";
      date1 = this.fromDate;
      date2 = this.toDate;
      let machineIds, zone, groupIds, jobSite, model;
      date1 = this.fromDate;
      date2 = this.toDate;
      machineIds = this.joinOrEmpty(this.selectedMachine, true);
      groupIds = this.joinOrEmpty(this.selectedGroup);
      model = this.joinOrEmpty(this.selectedModel);
      jobSite = this.joinOrEmpty(this.selectedJobSite);
      zone = this.joinOrEmpty(this.selectedZone);
      let accessControlCodes = this.joinOrEmpty(this.selectedAccessControlCodes);
      try {
        let response = await telematicsService.getOnReservationListExport(
          Number(this.selectedOwnershipFinal),
          date1,
          date2,
          machineIds,
          zone,
          groupIds,
          jobSite,
          accessControlCodes,
          model,
          searchValue,
          searchContractValue
        );
        if (response) {
          this.downloadFile(response);
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
        this.isDownloading = false;
      }
    },
    async readReportListFromApiPdf() {
      this.isDownloading = true;
      let date1 = "";
      let date2 = "";
      date1 = this.fromDate;
      date2 = this.toDate;
      let machineIds, zone, groupIds, jobSite, model;
      let searchValue = "";
      if (this.searchField) {
        searchValue = this.searchField;
      } else {
        searchValue = "";
      }
      let searchContractValue = "";
      if (this.searchContractId) {
        searchContractValue = this.searchContractId;
      } else {
        searchContractValue = "";
      }
      let accessControlCodes = this.joinOrEmpty(this.selectedAccessControlCodes);
      date1 = this.fromDate;
      date2 = this.toDate;
      machineIds = this.joinOrEmpty(this.selectedMachine, true);
      groupIds = this.joinOrEmpty(this.selectedGroup);
      model = this.joinOrEmpty(this.selectedModel);
      jobSite = this.joinOrEmpty(this.selectedJobSite);
      zone = this.joinOrEmpty(this.selectedZone);
      try {
        let response = await telematicsService.getOnReservationReportListPDF(
          Number(this.selectedOwnershipFinal),
          date1,
          date2,
          machineIds,
          zone,
          groupIds,
          jobSite,
          accessControlCodes,
          model,
          searchValue,
          searchContractValue
        );
        if (response) {
          this.downloadFilePDF(response);
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
        this.isDownloading = false;
      }
    },
    downloadFilePDF(apiResult) {
      if (apiResult) {
        this.triggerDownload(
          apiResult,
          "On Reservation Report.pdf",
          "application/pdf"
        );
      } else {
        this.isDownloading = false;
      }
    },
    downloadFile(response) {
      this.triggerDownload(
        response,
        "On Reservation Report.xlsx",
        "application/vnd.ms-excel"
      );
    },
    exportIconClick(item) {
      this.selectedExportOption = item;
      if (this.selectedExportOption) {
        this.isDownloading = true;
        //case  "excel"
        if (this.selectedExportOption == this.exportOptions[0]) {
          this.readReportListFromAPIExport();
        }
        //case  "Pdf"
        else if (this.selectedExportOption == this.exportOptions[1]) {
          this.readReportListFromApiPdf();
        }
      }
    },
    getFirstPageData() {
      this.pageNumber = 1;
      this.pageSize = 100;
      this.readReportListFromAPI();
    },
    getLastPageData() {
      this.pageNumber = this.totalRecords;
      this.pageSize = 100;
      this.readReportListFromAPI();
    },
    //All Report Filter Methods
    async getMachines() {
      try {
        this.loading = true;
        let response = await telematicsService.getMachines();
        if (response && response.data) {
          this.machines = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              tuUnitId: item.tuUnitId ? item.tuUnitId : "",
              machine: String(index),
              stockKey: item.stockKey ? item.stockKey : "",
            };
          });

          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getZones() {
      try {
        let response = await telematicsService.getZones();
        if (response && response.data) {
          this.zonesList = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              Zone: String(index),
            };
          });
        } else {
          this.zonesList = [];
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGroups() {
      try {
        this.loading = true;
        let response = await telematicsService.getGroups();
        if (response) {
          this.groups = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",

              group: String(index),
            };
          });

          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getLocations() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.locations = response.data.filter((e) => e.locationName != null);
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
        console.log(err);
      }
    },
    async getModels() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getModels();
        if (response) {
          this.models = response.data.map((item, index) => {
            return {
              name: item ? item : "",
              id: item ? item : "",

              model: String(index),
            };
          });

          this.loadingmodel = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    clearDates() {
      if (this.fromDate) {
        this.fromDate = "";
      }
      if (this.toDate) {
        this.toDate = "";
      }
    },
    resetGroup() {
      (this.selectedGroup = []), (this.reportDataList = []);
    },
    resetMachine() {
      (this.selectedMachine = []), (this.reportDataList = []);
    },
    resetZone() {
      this.selectedZone = [];
    },
    resetJobSite() {
      this.selectedJobSite = [];
    },
    resetModel() {
      this.selectedModel = [];
    },
    clearFilters() {
      this.fromDate = "";
      this.toDate = "";
      this.reportDataList = [];
      this.selectedGroup = [];
      this.selectedMachine = [];
      this.selectedModel = [];
      this.selectedZone = [];
      this.selectedJobSite = [];
      this.searchField = "";
      this.searchContractId = "";
      this.selectedOwnershipType = ["1", "2"];
      this.selectedOwnershipFinal = "0";
      this.selectedAccessControlCodesNames = [];
      this.selectedAccessControlCodes = [];
      this.readReportListFromAPI();
    },
    // scheduled reports api calls

    zoneChangeSchedule() {
      this.selectedZonesNamesSchedule = [];
      this.selectedZonesNamesSchedule = this.selectedZoneSchedule.map(
        (id) => this.zonesList.find((el) => el.id == id).name
      );
    },
    jobSiteChangeSchedule() {
      this.selectedJobSiteNamesSchedule = [];
      this.selectedJobSiteNamesSchedule = this.selectedJobSiteSchedule.map(
        (locationId) =>
          this.locations.find((el) => el.locationId == locationId).locationName
      );
    },
    modelChangeSchedule() {
      this.selectedModelNamesSchedule = [];
      this.selectedModelNamesSchedule = this.selectedModelSchedule.map(
        (id) => this.models.find((el) => el.id == id).name
      );
    },
    accessControlCodeChangeSchedule() {
      this.selectedAccessControlCodesNamesSchedule = [];
      this.selectedAccessControlCodesNamesSchedule =
        this.selectedAccessControlCodesSchedule.map(
          (serialNumber) =>
            this.accessControlCodes.find(
              (el) => el.serialNumber == serialNumber
            ).showCodeName
        );
    },

    resetGroupSchedule() {
      this.selectedGroupSchedule = [];
    },

    resetZoneSchedule() {
      this.selectedZoneSchedule = [];
      this.selectedZonesNamesSchedule = [];
    },
    resetJobSiteSchedule() {
      this.selectedJobSiteSchedule = [];

      this.selectedJobSiteNamesSchedule = [];
    },
    resetAccessControlCodesSchedule() {
      this.selectedAccessControlCodesSchedule = [];
      this.selectedAccessControlCodesNamesSchedule = [];
    },
    resetModelSchedule() {
      this.selectedModelSchedule = [];
      this.selectedModelNamesSchedule = [];
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    showScheduledForm() {
      this.readUsersFromAPI();
      this.scheduleedit = false;
      this.clearSchedule();
      this.displayScheduledForm = true;
    },
    async readUsersFromAPI() {
      let customerId =
        this.companyNameDropdown == "All" ||
        this.companyNameDropdown == "" ||
        this.companyNameDropdown == null
          ? ""
          : String(this.companyIdDropdown);

      try {
        let usersListRes;
        this.isLoaderUser = true;
        if (customerId == "") {
          usersListRes = await apiService.getUsersAll();
        } else {
          usersListRes = await apiService.getUsersByCustId(customerId);
        }
        if (usersListRes) {
          this.isLoaderUser = false;
          this.usersList = usersListRes.data.map((d, index) => ({
            ...d,
            name: d.firstName + " " + d.lastName,
            sno: index + 1,
          }));
        }
      } catch (err) {
        this.$toast.error("Unable to load the users" + err);
        this.isLoaderUser = false;
      }
    },
    cancelSchedule() {
      this.displayScheduledForm = false;
      this.scheduleedit = false;
      this.selectMonthlyDay = null;
      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledType = "";
      this.resetJobSiteSchedule();
      this.resetModelSchedule();
      this.resetAccessControlCodesSchedule();
      this.resetGroupSchedule();
      this.resetZoneSchedule();
      this.searchFieldSchedule = "";
      this.searchContractIdSchedule = "";
    },
    closeSchedule() {
      this.scheduledialog = false;
      this.clearSchedule();
    },
    clearSchedule() {
      this.selectMonthlyDay = null;
      this.selectedUser = "";
      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledType = "";
      this.resetJobSiteSchedule();
      this.resetModelSchedule();
      this.resetAccessControlCodesSchedule();
      this.resetGroupSchedule();
      this.resetZoneSchedule();
      this.searchFieldSchedule = "";
      this.searchContractIdSchedule = "";
    },
    openScheduledDialog() {
      this.displayScheduledForm = false;
      this.scheduledialog = true;
      this.getScheduledList();
    },
    EditScheduleDialog(item) {
      this.scheduleedit = true;
      this.readUsersFromAPI();
      this.selectedschedule = item;
      this.selectedcust = item.customerName;
      this.selectedUser = item.requestUserId;

      this.scheduleName = item.name;
      this.emails = item.emails.split(",");
      this.selectedDays =
        item.weekDays != null && item.weekDays != ""
          ? item.weekDays.split(",")
          : [];
      this.scheduledFrequency = item.frequency;
      this.scheduledType = item.format;
      this.displayScheduledForm = true;
      this.selectMonthlyDay =
        item.day != null && item.day != "" ? item.day : null;
      // filters

      item.parameters.filter((e) => {
        if (e.name == "groupIds" && e.value != "") {
          this.selectedGroupSchedule = e.value.split(",");
        }
        if (e.name == "zone" && e.value != "") {
          this.selectedZoneSchedule = e.value.split(",");
          this.selectedZonesNamesSchedule = this.selectedZoneSchedule.map(
            (id) => this.zonesList.find((el) => el.id == id).name
          );
        }
        if (e.name == "model" && e.value != "") {
          this.selectedModelSchedule = e.value.split(",");
          this.selectedModelNamesSchedule = this.selectedModelSchedule.map(
            (id) => this.models.find((el) => el.id == id).name
          );
        }
        if (e.name == "jobSite" && e.value != "") {
          this.selectedJobSiteSchedule = e.value.split(",");
          this.selectedJobSiteNamesSchedule = this.selectedJobSiteSchedule.map(
            (locationId) =>
              this.locations.find((el) => el.locationId == locationId)
                .locationName
          );
        }
        if (e.name == "accessCodes" && e.value != "") {
          this.selectedAccessControlCodesSchedule = e.value.split(",");
          this.selectedAccessControlCodesNamesSchedule =
            this.selectedAccessControlCodesSchedule.map(
              (serialNumber) =>
                this.accessControlCodes.find(
                  (el) => el.serialNumber == serialNumber
                ).showCodeName
            );
        }
        if (e.name == "searchKey" && e.value != "") {
          this.searchFieldSchedule = e.value;
        }
        if (e.name == "contractId" && e.value != "") {
          this.searchContractIdSchedule = e.value;
        }
      });

      //end filters
    },
    async CreateSchedule() {
      this.isSaveScheduleLoading = true;
      let zone, groupIds, jobSite, model, accessControlCodes;

      groupIds = this.joinOrEmpty(this.selectedGroupSchedule);
      model = this.joinOrEmpty(this.selectedModelSchedule);
      accessControlCodes = this.joinOrEmpty(
        this.selectedAccessControlCodesSchedule
      );
      jobSite = this.joinOrEmpty(this.selectedJobSiteSchedule);
      zone = this.joinOrEmpty(this.selectedZoneSchedule);
      let searchValue = "";
      if (this.searchFieldSchedule) {
        searchValue = this.searchFieldSchedule;
      } else {
        searchValue = "";
      }

      let searchContractValue = "";
      if (this.searchContractIdSchedule) {
        searchContractValue = this.searchContractIdSchedule;
      } else {
        searchContractValue = "";
      }
      let id, cust;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        cust = "";
        id = "";
      } else {
        cust = this.$store.getters.companyNameDropdown;
        id = this.$store.getters.companyIdDropdown;
      }
      let parameters = [
        {
          name: "groupIds",
          value: groupIds,
        },
        {
          name: "zone",
          value: zone,
        },
        {
          name: "model",
          value: model,
        },
        {
          name: "jobSite",
          value: jobSite,
        },
        {
          name: "accessCodes",
          value: accessControlCodes,
        },
        {
          name: "searchKey",
          value: searchValue,
        },
        {
          name: "contractId",
          value: searchContractValue,
        },
        {
          name: "pageNumber",
          value: "1",
        },
        {
          name: "pageSize",
          value: "-1",
        },
      ];
      let emails = this.emails.map((e) => e.trim());
      let payload = {
        reportId: this.ScheduleReportName,
        parameters: parameters,
        customer: String(id),
        customerName: cust,
        name: this.scheduleName,
        emails: emails.join(","),
        requestUserId: this.selectedUser != null ? this.selectedUser : "",
        weekDays:
          this.selectedDays.length != 0 ? this.selectedDays.toString() : null,
        frequency: this.scheduledFrequency,
        format: this.scheduledType,
        day:
          this.selectMonthlyDay != null && this.selectMonthlyDay != ""
            ? this.selectMonthlyDay
            : null,
      };
      try {
        let response = await telematicsService.createScheduledReport(payload);
        if (response.isSuccess) {
          this.isSaveScheduleLoading = false;
          this.$toast.success(" Schedule report  created successfully");
          this.displayScheduledForm = false;
          this.getScheduledList();
        } else {
          this.isSaveScheduleLoading = false;
          this.reportDataList = [];
        }
      } catch (err) {
        console.log(err);
        this.isSaveScheduleLoading = false;
      }
    },
    async UpdateSchedule() {
      this.isupdateScheduleLoading = true;
      let zone, groupIds, jobSite, model, accessControlCodes;

      groupIds = this.joinOrEmpty(this.selectedGroupSchedule);
      model = this.joinOrEmpty(this.selectedModelSchedule);
      accessControlCodes = this.joinOrEmpty(
        this.selectedAccessControlCodesSchedule
      );
      jobSite = this.joinOrEmpty(this.selectedJobSiteSchedule);
      zone = this.joinOrEmpty(this.selectedZoneSchedule);
      let searchValue = "";
      if (this.searchFieldSchedule) {
        searchValue = this.searchFieldSchedule;
      } else {
        searchValue = "";
      }

      let searchContractValue = "";
      if (this.searchContractIdSchedule) {
        searchContractValue = this.searchContractIdSchedule;
      } else {
        searchContractValue = "";
      }
      let id;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        id = "";
      } else {
        id = this.$store.getters.companyIdDropdown;
      }
      let parameters = [
        {
          name: "groupIds",
          value: groupIds,
        },
        {
          name: "zone",
          value: zone,
        },
        {
          name: "model",
          value: model,
        },
        {
          name: "jobSite",
          value: jobSite,
        },
        {
          name: "accessCodes",
          value: accessControlCodes,
        },
        {
          name: "searchKey",
          value: searchValue,
        },
        {
          name: "contractId",
          value: searchContractValue,
        },
        {
          name: "pageNumber",
          value: "1",
        },
        {
          name: "pageSize",
          value: "-1",
        },
      ];
      let emails = this.emails.map((e) => e.trim());
      let payload = {
        id: this.selectedschedule.id,
        reportId: this.ScheduleReportName,
        parameters: parameters,
        customer: String(id),

        name: this.scheduleName,
        customerName: this.selectedcust,
        emails: emails.join(","),
        requestUserId: this.selectedUser != null ? this.selectedUser : "",
        weekDays:
          this.selectedDays.length != 0 ? this.selectedDays.toString() : null,
        frequency: this.scheduledFrequency,
        format: this.scheduledType,
        day:
          this.selectMonthlyDay != null && this.selectMonthlyDay != ""
            ? this.selectMonthlyDay
            : null,
      };
      try {
        let response = await telematicsService.updateScheduledReport(
          this.selectedschedule.id,
          payload
        );
        if (response.isSuccess) {
          this.isupdateScheduleLoading = false;
          this.$toast.success(" Schedule report  updated successfully");
          this.displayScheduledForm = false;
          this.getScheduledList();
        } else {
          this.isupdateScheduleLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isupdateScheduleLoading = false;
      }
    },

    async getScheduledList() {
      this.isScheduledListLoading = true;
      let id;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        id = "";
      } else {
        id = this.$store.getters.companyIdDropdown;
      }

      try {
        let response = await telematicsService.getScheduledReportList(
          String(id),
          String(this.ScheduleReportName)
        );

        if (response.isSuccess) {
          this.isScheduledListLoading = false;
          this.scheduledList = response.data;
        } else {
          this.isScheduledListLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isScheduledListLoading = false;
      }
    },
    confirmDelete(item) {
      this.confirmdialog = true;
      this.selectedschedule = item;
    },
    async deleteSchedule() {
      try {
        this.isdelete = true;
        let response = await telematicsService.deleteSchedule(
          this.selectedschedule.id
        );
        if (response.isSuccess) {
          this.isdelete = false;
          this.$toast.success("Deleted Schedule report successfully");
          this.clearSchedule();
          this.displayScheduledForm = false;
          this.getScheduledList();
          this.confirmdialog = false;
          this.selectedschedule = {};
        } else {
          this.isdelete = false;
          this.$toast.success(response.systemMessage);
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete Schedule report" + err);
      }
    },
    OnFrequencyChange() {
      this.selectedDays = [];
      this.selectMonthlyDay = null;
    },
    // end scheduled reports methods
  },
};
